import WithGASetup from '../../../components/WithGASetup';
import AuthContext from '../../../context/AuthContext.js';
import ParticipantsPage from './ParticipantsPage.js';

export default WithGASetup(ParticipantsPage, AuthContext);
